var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab-note training-countdown",attrs:{"role":"status"}},[_c('b',[_vm._v("真实实训剩余 "+_vm._s(_vm.remaining))]),_vm._v(" · 首次开始后连续计时；案件模拟时钟由推进按钮控制，暂停不会延长真实截止时间。")])
}
var staticRenderFns = []

export { render, staticRenderFns }